export default {
  validate: (value, rule) => {
    if (rule === null) return true;
    const rulesArray = rule.split('|');

    function executeValidation(value, rule) {
      let result = true;
      let regexp = null;
      let number = null;
      switch (true) {
        case /^required$/.test(rule):
          result =
            isNullOrUndefined(value) ||
            isEmptyArray(value) ||
            !value ||
            (typeof value == 'string' && !value.trim())
              ? '必須項目です'
              : true;
          break;
        case /^max:[0-9]+$/.test(rule):
          if (isNullOrUndefined(value) || value === '') {
            result = true;
            break;
          }
          number = Number(rule.split(':')[1]);
          result =
            String(value).length <= number
              ? true
              : `${number}文字以下でなければなりません`;
          break;
        case /^min:[0-9]+$/.test(rule):
          if (isNullOrUndefined(value) || value === '') {
            result = true;
            break;
          }
          number = Number(rule.split(':')[1]);
          result =
            String(value).length >= number
              ? true
              : `${number}文字以上でなければなりません`;
          //TODO: にがらさんに確認
          break;
        case /^max_value:[0-9]+$/.test(rule):
          if (isNullOrUndefined(value) || value === '') {
            result = true;
            break;
          }
          number = Number(rule.split(':')[1]);
          result =
            Number(value) <= number ? true : `${number} 以下で入力してください`;
          break;
        case /^min_value:[0-9]+$/.test(rule):
          if (isNullOrUndefined(value) || value === '') {
            result = true;
            break;
          }
          number = Number(rule.split(':')[1]);
          result =
            Number(value) >= number ? true : `${number} 以上で入力してください`;
          break;
        case /^checked_max:[0-9]+$/.test(rule):
          if (isNullOrUndefined(value) || isEmptyArray(value)) {
            result = true;
            break;
          }
          number = Number(rule.split(':')[1]);
          result =
            Array.isArray(value) && value.length <= number
              ? true
              : `選択できるのは${number}個までです`;
          break;
        case /^checked_min:[0-9]+$/.test(rule):
          if (isNullOrUndefined(value) || isEmptyArray(value)) {
            result = true;
            break;
          }
          number = Number(rule.split(':')[1]);
          result =
            Array.isArray(value) && value.length >= number
              ? true
              : `${number}個以上選択してください`;
          break;
        case /^tel$/.test(rule):
          if (isNullOrUndefined(value) || value === '') {
            result = true;
            break;
          }
          value = value.replace(/[‐－―～ー￣]/g, '-');
          if (!value.match(/^0[0-9]{1,4}-?[0-9]{2,4}-?[0-9]{3,4}$/)) {
            result = '電話番号が正しくありません';
          } else {
            value = value.replace(/-/g, '');
            const value_length = value.match(/^0[1-9]0/) ? 11 : 10;
            if (value.length != value_length) {
              result = '電話番号が正しくありません';
            }
          }
          break;
        case /^email$/.test(rule):
          if (isNullOrUndefined(value) || value === '') {
            result = true;
            break;
          }
          regexp =
            /^[A-Za-z0-9]{1}[A-Za-z0-9_.+-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/;
          result = regexp.test(value)
            ? true
            : '有効なメールアドレスではありません';
          break;
        case /^alpha_num$/.test(rule):
          if (isNullOrUndefined(value) || value === '') {
            result = true;
            break;
          }
          regexp = /^[A-Za-z0-9]*$/;
          result = regexp.test(value) ? true : '半角英数字のみ使用できます';
          break;
        case /^alpha_num_special$/.test(rule):
          if (isNullOrUndefined(value) || value === '') {
            result = true;
            break;
          }
          /* eslint-disable no-useless-escape */
          regexp = /^[A-Za-z0-9`˜!@#$%^&*()_+-={}\[\]\\\|:;'<>?\/]*$/;
          result = regexp.test(value)
            ? true
            : '半角英数字と記号のみ使用できます';
          break;
        case /^url$/.test(rule):
          if (isNullOrUndefined(value) || value === '') {
            result = true;
            break;
          }
          regexp = /^(https|http):\/\/.+/;
          result = regexp.test(value) ? true : 'URLが正しくありません';
          break;
        case /^zip$/.test(rule):
          if (isNullOrUndefined(value) || value === '') {
            result = true;
            break;
          }
          regexp = /^[0-9]{3}-[0-9]{4}$/;
          result = regexp.test(value) ? true : '郵便番号が正しくありません';
          break;
        case /^date$/.test(rule):
          if (isNullOrUndefined(value) || value === '') {
            result = true;
            break;
          }
          if (/^[0-9]{4}[-/][0-9]{1,2}[-/][0-9]{1,2}$/.test(value)) {
            const ymd = value.split(/[-/]/);
            const date = new Date(ymd[0], ymd[1] - 1, ymd[2]);
            if (
              date.getFullYear() == ymd[0] &&
              date.getMonth() == ymd[1] - 1 &&
              date.getDate() == ymd[2]
            ) {
              result = true;
              break;
            }
          }
          result = '日付が正しくありません';
          break;
        case /^integer$/.test(rule):
          if (isNullOrUndefined(value) || value === '') {
            result = true;
            break;
          }
          regexp = /[^0-9]+/;
          result = regexp.test(value) ? '半角数字のみ使用できます' : true;
          break;
        case /^double$/.test(rule):
          if (isNullOrUndefined(value) || value === '') {
            result = true;
            break;
          }
          regexp = /^[0-9]+\.[0-9]+$/;
          result = regexp.test(value)
            ? true
            : '小数のみ使用できます、小数点が必要です';
          //TODO: にがらさんに確認
          break;
        case /^name$/.test(rule):
          result =
            isNullOrUndefined(value) ||
            isEmptyArray(value) ||
            !value ||
            (typeof value == 'string' && !value.trim())
              ? '※項目名を入力してください'
              : true;
          break;
        case /^quantity$/.test(rule):
          result =
            isNullOrUndefined(value) || (!value && value !== 0)
              ? '※個数を入力してください'
              : true;
          break;
        case /^price$/.test(rule):
          result =
            isNullOrUndefined(value) || (!value && value !== 0)
              ? '※単価を入力してください'
              : true;
          break;
      }
      return result;
    }

    function isNullOrUndefined(value) {
      return value === null || value === undefined;
    }
    function isEmptyArray(value) {
      return Array.isArray(value) && value.length === 0;
    }

    let result = true;
    for (let i = 0; i < rulesArray.length; i++) {
      result = executeValidation(value, rulesArray[i]);
      if (result !== true) {
        break;
      }
    }

    return result;
  },
};
